import { z } from "zod";

export const validationSchema = z.object({
  name: z.string().min(2, { message: "business.form.errors.name.min" }).regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, { message: "business.form.errors.name.regex" }),
  email: z.string().email("business.form.errors.email"),
  phone: z.string().regex(/\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}/, { message: "business.form.errors.phone" }),
  activity: z.string().min(2, { message: "business.form.errors.activity" }),
  agreed: z.literal(true, {
    errorMap: () => ({ message: "business.form.errors.agreed" }),
  }),
});